<template>
  <div class="bg-white min-h-screen px-4">
    <div class="container mx-auto sm:px-4 pt-24 pb-20">
      <Sidebar></Sidebar>
      <Header> {{$t('all.chat_class')}} {{email.classroom_name}}
        <CommunicationHeader>
          <div slot="left">
            <p class="text-white text-sm">{{$t('all.minors')}}</p>
          </div>
        </CommunicationHeader>
      </Header>
      <div class="pt-4">
        <div
          class="block pb-4"
          v-for="minor in email.minors"
          :key="minor.id"
        >
          <div class="flex justify-between border-b border-dashed border-blue">
            <div class="flex relative pb-2">
              <img
                src="/img/user.png"
                class="w-8 h-8 rounded-full align-middle z-3 relative"
              >
              <h4 class="pt-3 pl-2 text-sm font-bold text-blue">{{minor.name}} {{minor.surname}}</h4>
            </div>
            <div class="flex pt-3">
              <i
                class="fas fa-check-double fa-xs"
                :class="minor.is_read ? 'text-blue' : 'text-grey-light'"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CommunicationReceivers',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      email: 'communication/email',
    }),
  },
  methods: {
    ...mapActions('communication', ['getOutboxEmail']),
  },
  created() {
    this.getOutboxEmail(this.$route.params);
  },
};
</script>
